import { GlFilteredSearchSuggestion } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import { s__, sprintf } from '~/locale';
import BaseToken from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/filtered_search_bar/tokens/base_token.vue?vue3';
import customFieldOptionsQuery from 'ee/work_items/graphql/work_item_custom_field_select_options.query.graphql';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
export default {
    name: 'CustomFieldToken',
    components: {
        BaseToken,
        GlFilteredSearchSuggestion
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        active: {
            type: Boolean,
            required: true
        },
        config: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            options: [],
            loading: true,
            hasStartedQuery: false
        };
    },
    computed: {
        fieldId () {
            return this.config.field?.id;
        }
    },
    methods: {
        getActiveOption (options, data) {
            return options.find((option)=>this.getId(option) === data);
        },
        async fetchCustomFieldOptions (searchTerm = '') {
            if (!this.fieldId) {
                return;
            }
            let shouldFilter = true;
            // if we have a search term on initial load
            // then it is an ID, so don't filter search results by it
            if (searchTerm && !this.hasStartedQuery) {
                shouldFilter = false;
            }
            this.hasStartedQuery = true;
            this.loading = true;
            await this.$apollo.query({
                query: customFieldOptionsQuery,
                variables: {
                    fieldId: this.fieldId
                }
            }).then(({ data })=>{
                const { customField } = data;
                this.options = customField?.selectOptions || [];
                if (shouldFilter) {
                    this.options = this.options.filter((option)=>option.value.toLowerCase().includes(searchTerm.toLowerCase()));
                }
            }).catch((error)=>{
                const message = sprintf(s__('WorkItemCustomFields|Options could not be loaded for field: %{dropdownLabel}. Please try again.'), {
                    dropdownLabel: this.config.field?.name || 'UNKNOWN_FIELD'
                });
                createAlert({
                    message,
                    captureError: true,
                    error
                });
            }).finally(()=>{
                this.loading = false;
            });
        },
        getId (option) {
            return getIdFromGraphQLId(option.id).toString();
        },
        getOptionText (option) {
            return option.value;
        }
    }
};
